import { render, staticRenderFns } from "./UplimitPromotion.vue?vue&type=template&id=def36c7c&scoped=true"
import script from "./UplimitPromotion.vue?vue&type=script&lang=js"
export * from "./UplimitPromotion.vue?vue&type=script&lang=js"
import style0 from "./UplimitPromotion.vue?vue&type=style&index=0&id=def36c7c&prod&scoped=true&lang=css"
import style1 from "./UplimitPromotion.vue?vue&type=style&index=1&id=def36c7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def36c7c",
  null
  
)

export default component.exports